import React from 'react'
import { PromptStyle } from '@pushly/models/lib/enums'
import { StyleTileGroup, StyleTileOption, Well } from '@pushly/aqe/lib/components'
import { PromptStyleDiagram } from './prompt-style-diagram'

type PromptTreatmentStyleSelectorProps = {
    loading?: boolean
    value?: PromptStyle
    onChange: (value: PromptStyle) => void
}

const DEFAULT_PROMPT_STYLE = PromptStyle.NATIVE

const OPTIONS: StyleTileOption<PromptStyle>[] = [
    { value: PromptStyle.NATIVE, label: 'System Prompt' },
    { value: PromptStyle.SLIDE, label: 'Slide Prompt' },
    { value: PromptStyle.PUBLISHER_CUSTOM, label: 'Custom Prompt' },
]

export const PromptStyleSelector: React.FC<PromptTreatmentStyleSelectorProps> = ({ value, onChange }) => (
    <Well title="Style" hideFooter={true} mode="ghost" flush>
        <StyleTileGroup<PromptStyle>
            className="prompt-style-options"
            aria-label="Prompt style"
            layout="vertical"
            tileWidth={130}
            tileHeight={110}
            value={value ?? DEFAULT_PROMPT_STYLE}
            onChange={onChange}
            options={OPTIONS.map((option) => ({
                ...option,
                visual: <PromptStyleDiagram style={option.value} />,
            }))}
        />
    </Well>
)
